export {Badge, StyledRmwcBadge} from './badge'
